export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-scale/src/number.js
// module id = B+tz
// module chunks = 0